import {
  GET_AUTH_PROVIDER_URL,
  GET_AUTH_PROVIDER_URL_SUCCESS,
  GET_AUTH_PROVIDER_URL_FAILURE,
  SEND_EXTERNAL_AUTH_TOKEN,
} from 'actionTypes';

const initialProviderState = {
  url: null,
  shouldFetch: true,
};

export default function authReducer(state = {}, action) {
  const { type, provider, providerURL } = action;
  switch (type) {
    case GET_AUTH_PROVIDER_URL:
      return {
        ...state,
        [provider]: initialProviderState,
      };
    case GET_AUTH_PROVIDER_URL_SUCCESS:
      return {
        ...state,
        [provider]: {
          url: providerURL,
          shouldFetch: false,
        },
      };
    case GET_AUTH_PROVIDER_URL_FAILURE:
      return {
        ...state,
        [provider]: {
          url: null,
          shouldFetch: false,
        },
      };
    case SEND_EXTERNAL_AUTH_TOKEN:
      return {
        ...state,
        [provider]: initialProviderState,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authProvidersReducer.js